// extracted by mini-css-extract-plugin
export default {"container":"pagination-component_container__T4OvO","truncate-table":"pagination-component_truncate-table__09Vom","table-text-faded":"pagination-component_table-text-faded__x2iBF","pagination":"pagination-component_pagination__8OWkW","list":"pagination-component_list__Nz2eu","active":"pagination-component_active__B7X1s","skip":"pagination-component_skip__wV6qt","skipNext":"pagination-component_skipNext__HFtgj"};
    if(module.hot) {
      // 1792500642792
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  